import script from "./BranchAdminNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./BranchAdminNotice.vue?vue&type=script&setup=true&lang=ts"

import "./BranchAdminNotice.vue?vue&type=style&index=0&id=654a3e8e&lang=css"

const __exports__ = script;

export default __exports__